import {useCallback, useEffect, useState} from "react";
import { allCountries } from 'country-region-data';
import {Select} from "@shopify/polaris";

const CountryNameKey = 0;
const CountrySlugKey = 1;
const CountryRegionsKey = 2;

const RegionNameKey = 0;
const RegionSlugKey = 1;

export const CountrySelector = ({value =  '', onChange = () => {}, error, disabled = false}) => {
    const getOptions = () => {
        return allCountries.map((country) => {
            return {
                value: country[CountrySlugKey],
                label: country[CountryNameKey]
            };
        });
    };

    return (<>
        <Select
            placeholder={"- Select Country -"}
            label={"Country"}
            options={getOptions()}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
        ></Select>
    </>)
}

export const StateSelector = ({value =  '', onChange = () => {}, selectedCountry = '', error, disabled = false}) => {
    const getOptions = () => {
        let regions = [];

        allCountries.forEach((country) => {
            if (country[CountrySlugKey] === selectedCountry) {
                regions = country[CountryRegionsKey];
            }
        });

        return regions.map((region) => {
            return {
                value: region[RegionSlugKey],
                label: region[RegionNameKey]
            };
        });
    };

    return (<>
        <Select
            placeholder={"- Select State -"}
            label={"State"}
            options={getOptions()}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
        ></Select>
    </>)
}
